import { FC } from 'react'
import styled from 'styled-components'
import { tokens } from '@JOTAJornalismo/jota-design-system'
import { CardDS } from '../../libs/components'
import { ProLastNews } from '../model/pro-nl'
import { returnPROLink } from '../utils/geral'
import { StoreType } from '@App/api/types/store'
import { useSelector } from 'react-redux'
import { SM_PX } from './header/Header.styled'
import { useRouter as nextRouter } from 'next/router'
import { isContentPro, isUserPro } from '../utils/pro'

const { colors, fonts, spaces } = tokens

const LastNews: FC<{ news: ProLastNews[] }> = ({ news }): React.JSX.Element => {
    const { query } = nextRouter()

    const getMonthName = (month: number) => {
        const monthName = [
            'janeiro',
            'fevereiro',
            'março',
            'abril',
            'maio',
            'junho',
            'julho',
            'agosto',
            'setembro',
            'outubro',
            'novembro',
            'dezembro'
        ]
        return monthName[month - 1]
    }

    const { auth } = useSelector((state: StoreType) => state)

    const formatDate = (lastNew: ProLastNews) => {
        const day = new Date(lastNew._source.source.published_at).getDate()
        const month =
            new Date(lastNew._source.source.published_at).getMonth() + 1
        const year = new Date(lastNew._source.source.published_at).getFullYear()
        const formatedDate = `${day} de ${getMonthName(month)} de ${year}`
        return formatedDate
    }

    const formatHour = (lastNew: ProLastNews) => {
        const hour = new Date(lastNew._source.source.published_at).getHours()
        const minute = new Date(
            lastNew._source.source.published_at
        ).getMinutes()
        const formatedHour = `${hour}:${minute}`
        return formatedHour
    }

    return (
        <Container>
            <Title>Últimas</Title>
            <CardsContainer>
                {news?.map((lastNew: any) => {
                    return (
                        <CardDS
                            key={lastNew?._source.title.headline}
                            authorTagOnClick={() => {
                                return null
                            }}
                            authorTagType='colored'
                            newsLink={returnPROLink(
                                lastNew?._source?.source?.slug,
                                lastNew._source.vertical.slug,
                                lastNew?._source?.categories[0].slug
                            )}
                            relatedTagOnClick={function noRefCheck() {
                                return null
                            }}
                            size={'small'}
                            subjectTagOnClick={function noRefCheck() {
                                return null
                            }}
                            subjectTagType='filled'
                            tagColor={
                                lastNew?._source.vertical.slug === 'tributos' ||
                                query.vertical === 'saude'
                                    ? 'jotaGreen'
                                    : 'jotaBlue'
                            }
                            tagLabel={lastNew?._source?.categories[0]?.name}
                            tagDisableHover
                            tagOnClick={function noRefCheck() {
                                return null
                            }}
                            tagType='colored'
                            title={lastNew?._source.title.headline}
                            titleSearchTerm={''}
                            dateTagLabel={formatDate(lastNew)}
                            dateTagDisableHover
                            relatedTagLabel={formatHour(lastNew)}
                            relatedTagDisableHover
                            type={
                                lastNew.type === 'pro' ? 'elevation' : 'normal'
                            }
                            isContentPro={isContentPro(
                                lastNew._source.vertical.name.toLowerCase(),
                                auth
                            )}
                            isUserPro={isUserPro(
                                lastNew._source.vertical.name.toLowerCase(),
                                auth
                            )}
                            hasSeparator={false}
                        />
                    )
                })}
            </CardsContainer>
        </Container>
    )
}

export default LastNews

const Container = styled.div`
    @media (max-width: ${SM_PX}) {
        padding: ${spaces.jotaSpacing12};
    }
    padding: ${spaces.jotaSpacing44};
`

const CardsContainer = styled.li`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${spaces.jotaSpacing44};
    padding-top: 24px;

    @media (max-width: ${SM_PX}) {
        display: flex;
        flex-direction: column;
    }
`

const Title = styled.h4`
    ${fonts.jotaHeading04()};
    color: ${colors.black.jotaBlack};
    border-bottom: 1px solid ${colors.transparent.jotaTGrayLight40};
    margin: 0;
    padding-bottom: 8px;
    font-style: normal;
`
